import { ProgressBarBg, ProgressBarItem, ProgressBarWrapper, ProgressPercentage } from './ProgressBar.styled'

interface ProgressBarProps {
  $progress: string | number
  height?: string
  $customColor?: string | null
}

const ProgressBar = ({ $progress, height = '5px', $customColor }: ProgressBarProps) => {
  return (
    <>
      <ProgressBarWrapper>
        <ProgressBarBg height={height}>
          <ProgressBarItem $progress={Number($progress)} height={height} $customColor={$customColor} />
        </ProgressBarBg>
      </ProgressBarWrapper>
      <ProgressPercentage>{$progress}%</ProgressPercentage>
    </>
  )
}

export default ProgressBar
